<template>
	<div class="MObjHistory">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card card-body-classes="table-full-width">
			<!-- <pre>{{ this.masHistory }}</pre> -->
			
			<!-- Не удаляем таблицу ТОЛЬКО с историей цены на случай возвращения хотелок заказчиков -->
			 <!-- <div>
				<el-table :data="masHistory" class="my_hover">
					<el-table-column
						min-width="100"
						prop="dateInsert"
						label="Дата изменения"
					>
					</el-table-column>
				
					<el-table-column
						min-width="100"
						prop="price_old"
						label="Старая цена"
					>
					<template slot-scope="scope">
						{{$GVO.number_format(scope.row.price_old,0,'.',' ')}}
					</template>
					</el-table-column>
					<el-table-column
						min-width="100"
						prop="price_new"
						label="Новая цена"
					>
					<template slot-scope="scope">
						{{$GVO.number_format(scope.row.price_new,0,'.',' ')}}
					</template>
					</el-table-column>
					<el-table-column
						min-width="100"
						prop="staff_code"
						label="Кто изменил"
					>
					<template slot-scope="scope">
						<a :href="'/data/staff/id/'+scope.row.staff_code">{{scope.row.staff_fio}}</a>
					</template>
					</el-table-column>
				</el-table>
			</div> -->

			 <div>
				<el-table 
					:data="masHistory" 
					style="width: 100%; margin-bottom: 0px; margin-top: 30px;"
					
					default-expand-all >

					<!-- <el-table-column
						min-width="100"
						prop="data"
						label="data"
					>
					<template slot-scope="scope">
						<el-table
							:data="flat_object(scope.row.data)"
							:row-class-name="tableDataClassName"
							>

							<el-table-column
								prop="name"
								label="Имя">
								<template slot-scope="scope2">
									{{fields_name[scope2.row.name]||scope2.row.name}}
								</template>
							</el-table-column>
							<el-table-column
							prop="old"
							label="Было">
							</el-table-column>
							<el-table-column
							prop="new"
							label="Стало">
							</el-table-column>
						</el-table>
					</template>
					</el-table-column> -->

					
					<!-- 
					<el-table-column
						min-width="100"
						prop="data"
						label="data"
					>
					<template slot-scope="scope">
						
					</template>
					</el-table-column> -->

					<el-table-column type="expand">
						<template v-slot="scope">
							<el-table
								:data="flat_object(scope.row.data)"
								:row-class-name="tableDataClassName"
								style="width: 100%; margin-bottom: 0px; margin-top: 0px;"
								header-cell-class-name="my-header"
								>

								<el-table-column
									prop="name"
									label="Описание изменения"
									min-width="200px">
									<template v-slot="scope2">
										<span :class="{'text-warning' : (scope2.row.name == 'moderation_status' || scope2.row.name == 'moderation_text')}">{{fields_name[scope2.row.name]||scope2.row.name}}</span>
										<!-- <div> fields_name{{fields_name[scope2.row.name]}}</div>
										<div> scope2.row.name {{scope2.row.name}}</div> -->
									</template>
								</el-table-column>
								<el-table-column
									prop="new"	
									min-width="500px"
									label="Разница">
									<template v-slot="scope5">
										<!-- <div v-if="scope4.row.new === true">Да</div>
										<div v-if="scope4.row.new === false">Нет</div>
										<div v-if="scope4.row.new != '' && typeof scope4.row.new != 'boolean'">{{scope4.row.new}}</div> -->
										<CodeDiff
											language="plaintext"
											:old-string="scope5.row.old"
											:new-string="scope5.row.new"
											output-format="side-by-side"
											:context="10"
											diffStyle="word"
											theme="light"
											hideHeader
											trim
											noDiffLineFeed
											/>
									</template>
								</el-table-column>
								<!-- <el-table-column
									prop="old"
									label="Было">
									<template slot-scope="scope3">
										<div v-if="scope3.row.old === true">Да</div>
										<div v-if="scope3.row.old === false">Нет</div>
										<div v-else>{{scope3.row.old}}</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="new"	
									label="Стало">
									<template slot-scope="scope4">
										<div v-if="scope4.row.new === true">Да</div>
										<div v-if="scope4.row.new === false">Нет</div>
										<div v-if="scope4.row.new != '' && typeof scope4.row.new != 'boolean'">{{scope4.row.new}}</div>
									</template>
								</el-table-column> -->
								
							</el-table>
							
						</template>
					</el-table-column>

					<el-table-column
						min-width="100"
						prop="dateInsert"
						label="Дата изменения"
						
					>
						<template v-slot="scope">
							<div class="datestyle">{{$GVO.convertDateTimeFromMysql(scope.row.dateInsert)}}</div>
						</template>
					</el-table-column>

					<el-table-column
						min-width="100"
						prop="staff_code"
						label="Кто изменил"
						align="right"
					>
						<template v-slot="scope">
							<router-link :to="'/data/staff/id/'+scope.row.staff_code">{{scope.row.staff_fio}}</router-link>
						</template>
					</el-table-column>

				</el-table>
			</div>

		</card>
		<!-- <div class="d-flex justify-content-center justify-content-sm-between flex-wrap"> -->
		<div class="d-flex ">
			<Pagination :class="[{'': parseInt(history_total) > 0}, {'d-none': parseInt(history_total) < 1}]"
				:type="'info'" 
				:total="parseInt(history_total)" 
				:perPage="parseInt(10)" 
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</div>
	</div>
</template>
<script>

import { Table, TableColumn } from 'element-ui';
import Pagination from 'src/our_components/RePagination';
import { CodeDiff } from 'v-code-diff'

export default {
	name: 'MObj_history-page',
	components: {
		Pagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		CodeDiff,
	},
	data() {
		return {
			masHistory: [],
			history_total:0,
			searchQuery:'',
			backCounter:1,
			objGetParams: {},
			// Преобразования названия полей
			fields_name:{
				offerType: 'Тип предложения',
				dealType: 'Тип операции',
				price: 'Цена',
				Period: 'Срок аренды',
				PriceType: 'Период оплаты',
				deposit: 'Депозит',
				prepayment: 'Предоплата, мес.',
				parts_price: 'Цена части',
				VatType: 'Налог',
				utilities: 'Коммунальные услуги',
				commission: 'Размер комиссии, %',
				object_name: 'Заголовок объявления',
				square: 'S общая',
				usefulSquare: 'S полезная',
				parts_square: 'S части',
				kitchenSquare: 'S кухни',
				chambers: 'S комнат',
				landSquare: 'S участка',
				minSquare: 'Минимальная S',
				roomsCount: 'Комнат продается',
				roomsCountTotal: 'Комнат всего',
				separatedRoomsCount: 'Комнат раздельно',
				byPart: 'Можно частями',
				floor: 'Этаж',
				floors: 'Этажность',
				flatStatus: 'Статус объекта',
				material: 'Материал стен',
				Toilet: 'Санузел',
				Heating: 'Отопление',
				Furniture: 'Мебель',
				CommissionType: 'Тип комиссии',
				flatHouseType: 'Тип здания',
				series: 'Серия дома',
				
				HouseType: 'Тип дома',
				privatization: 'Приватизированная квартира',
				apartments: 'Апартаменты',
				neighbor: 'Соседей в квартире',
				burden: 'Есть обременения',
				sharePercent: 'Размер доли, %',
				'sharePercent/sharePart': 'Размер доли (часть)',
				'sharePercent/shareAll': 'Размер доли (всего)',
				mortgage: 'Ипотека',
				credit: 'Рассрочка',
				exclusiveContract: 'Эксклюзивный договор с собственником',
				maxPeople: 'Эксклюзивный договор с собственником',
				BuildingClass: 'Класс здания',
				Layout: 'Планировка',
				FlatMaterial: 'Материал стен',
				BuildingType: 'Тип здания',
				ObjectCondition: 'Состояние объекта',
				centerName: 'Название БЦ',
				parkingPlaces: 'Количество парковочных мест',
				ParkingType: 'Тип парковки',
				BusinessUsageType: 'Тип использования коммерческого помещения',
				hallSquare: 'Площадь холла',
				EntryType: 'Вход в объект',
				standaloneBuilding: 'Отдельностоящее здание',
				readyBusiness: 'Готовый бизнес',
				year: 'Год постройки',
				LandUsageType: 'Использование земли',
				communityName: 'Название сообщества',
				Purpose: 'Назначение земли',
				railway: 'Ж/Д станция',
				railwayDistance: 'До Ж/Д станции, км',
				railwayDistanceType: 'Тип расстояния',
				forestDistance: 'До леса, км',
				waterDistance: 'До водоема, км',
				Shape: 'Форма участка',
				Relief: 'Рельеф',
				Electricity: 'Электроснабжение',
				Gas: 'Газификация',
				Plumbing: 'Водоснабжение',
				plumbing: 'Водоснабжение',
				Sewerage: 'Канализация',
				WarehouseType: 'Тип складского помещения',
				Conditioning: 'Система контроля климата',
				Condition: 'Состояние коммерческого помещения',
				storageType: 'Тип хранения',
				floorPressure: 'Нагрузка на пол, тонн',
				columnSpace: 'Шаг колонн, м',
				power: 'Подведенная мощность, кв',
				warehouseFloor: 'Покрытие полов',
				Unloading: 'Разгрузка',
				Gate: 'Въезд',
				HighwayAccess: 'Транспортная доступность',
				StructureType: 'Тип здания',
				sublease: 'Субаренда',
				GarageType: 'Тип гаража',
				stories: 'Этажность здания',
				GarageMaterial: 'Материал стен',
				totalParkingLots: 'Общее количество машиномест',
				assignmentOfLeaseRights: 'Переуступка права аренды',
				ParkingLotType: 'Тип стоянки',
				newFlat: 'Готовность объекта',
				firstSale: 'Первичная продажа вторички',
				readyDate_quarter: 'Дата сдачи',
				readyDate_year: 'Дата сдачи',
				developer: 'Застройщик',
				buildingName: 'Название ЖК',
				documentationUrl: 'Ссылка на проектную документацию',
				reassignment: 'Переуступка',
				investorType: 'Тип дольщика',
				investorLastName: 'Фамилия дольщика',
				investorFirstName: 'Имя дольщика',
				investorPatronymic: 'Отчество дольщика',
				investorInn: 'ИНН (если дольщик юр. лицо)',
				cadastralNumber: 'Кадастровый номер',
				renovation: 'Ремонт',
				// plumbing: 'Водоснабжение',
				ceilingHeight: 'Высота потолка, см',
				Balcony: 'Количество балконов',
				Elevator: 'Пассажирских лифтов',
				ServiceElevator: 'Грузовых лифтов',
				WindowView: 'Вид из окон',
				windowMaterial: 'Материал окон',
				ApartmentPosition: 'Расположение окон в доме',
				door: 'Входная дверь',
				flatFloor: 'Покрытие пола',
				feature: 'Опции',
				videoUrl: 'Видео',
				description: 'Описание',
				photos: 'Фото',
				agrm_number: 'Договор',
				
				DistanceType: 'Тип расстояния до ж/д',
				distanceToMetro: 'Расстояние до метро, мин.',
				landCadastralNumber: 'Кадастровый номер земельного участка',
				isOffice: 'Офис',
				hotWater: 'Горячая вода',
				bathType: 'Тип ванны',
				balcony: 'Количество балконов',
				Loggia: 'Количество лоджий',
				apartmentPosition: 'Расположение в доме',
				type: 'Тип квартиры',
				flatType: 'Тип квартиры',
				market: 'Рынок',
				adserrors: 'Ошибки от площадок',
				Ownership: 'Собственность', 
				AddressPresentationType: 'Представление адреса',
				metro_name: 'Метро',
				metro_id: 'ИД метро',
				distanceType: 'Тип доступности',
				distr_name: 'Название района',
				distr_id: 'Номер района',
				draft: 'Черновик',
				'agrm_type': 'Тип отношений',
				'chambers/textval': 'Площадь комнат',
				// 'MapAddress/arrMetro/0/metro_name':'Метро',
				// 'MapAddress/distr_name':'Название района',
				// 'MapAddress/arrMetro/0/distanceType':'Тип доступности',
				'MapAddress/address/ad8_name':'Номер дома/офиса/помещения/земли',
				'MapAddress/address/inputText':'Адрес',
				'MapAddress/address/text':'Адрес',
				'MapAddress/coords/0':'Широта',
				'MapAddress/coords/1':'Долгота',
				'MapAddress/flat_num': 'Номер дома/офиса/помещения/земли',
				// 'MapAddress/distr_id': 'Номер района',
				'MapAddress/address/regioncode': 'Номер региона',
				'moderation_status_id': 'Статус модерации',
				'moderation_status': 'Статус модерации',
				moderation_text: 'Причины отклонения объекта'

			},
			// массив полей которые мы скроем от пользователя.
			hidden_fields: 'service_id,task_id,,search_text_field,cFirmDogId,agent_id,'+
				'MapAddress/address/regionname,MapAddress/address/text_addr,MapAddress/address/selectedVal,'+
				'MapAddress/address/ad4_name,MapAddress/address/ad5_name,MapAddress/address/ad6_name,'+
				'MapAddress/address/ad4_id,MapAddress/address/ad4_short,MapAddress/address/ad5_id,MapAddress/address/ad5_short,MapAddress/address/ad6_id,MapAddress/address/ad6_short,MapAddress/address/ad7_id,MapAddress/address/ad7_name,MapAddress/address/ad7_short,MapAddress/address/ad8_short,MapAddress/address/ad8_id'+
				'chambers/roomSum'.split(',')
		};
	},
	computed:{
		flat_object(){
			let vm=this;
			return function(data){
				let result=[];
				// debugger;
				// console.log(data);
				Object.keys(data).forEach((key)=>{
					let keyName = key;
					if(key=='name') keyName= 'object_name';
					if(Object.prototype.hasOwnProperty.call(data[key], 'old')){
						if(key == 'sharePercent'){
							// console.log('ffff', data[key].new.sharePart);
							const sharePart = '';
							const shareAll = '';
							if((data[key].new.sharePart== '') || (data[key].new.shareAll== '')){
								data[key].new = ''; 
								// console.log('ffff undefind', data[key].new);
							}
							if((data[key].old.sharePart== '') || (data[key].old.shareAll== '')){
								data[key].old = ''; 
								// console.log('ffff undefind', data[key].new);
							}							
						}

						let oldText =  data[key].old;
						let newText =  data[key].new;
						// console.log('oldText', oldText);
						if(oldText == true) {
							oldText = 'Да';
						}else if(oldText == false) {
							oldText = 'Нет';
						} 
						if(newText == false) {
							newText = 'Нет';
						}else if(newText == true) {
							newText = 'Да';
						}
						result.push({name:keyName, old:oldText.toString().replaceAll('\n', ' '), new:newText.toString().replaceAll('\n', ' ')});
						// result.push({name:key, old:data[key].old.toString().replaceAll('\n', ' '), new:data[key].new.toString().replaceAll('\n', ' ')});
						// console.log('ffff', key);
					}
					else{
						vm
							.flat_object(data[key])
							.forEach(row=>{
								// console.log('ffff', key);
								// if(key == 'metro_name'){console.log('ffff', key);}
								if(key == 'feature'){
									row.name = this.fields_name.feature; 
								} 
								else if (key == 'photos'){
									row.name = this.fields_name.photos;
								} 
								else if (key == 'MapAddress'){

									row.name=key+'/'+row.name;

									const arrMapAddress = row.name.split('/');
									const lastElement = arrMapAddress.pop();
									if(lastElement == 'metro_name'){row.name = this.fields_name.metro_name;}
									if(lastElement == 'distanceToMetro'){row.name = this.fields_name.distanceToMetro;}
									if(lastElement == 'metro_id'){row.name = this.fields_name.metro_id;}
									if(lastElement == 'distanceType'){row.name = this.fields_name.distanceType;}
									if(lastElement == 'distr_name'){row.name = this.fields_name.distr_name;}
									if(lastElement == 'distr_id'){row.name = this.fields_name.distr_id;} 

									// console.log(lastElement); 
								}
								else {
									row.name=key+'/'+row.name;
								}
								
								result.push(row);
								
							})
					}
					// console.log(result);
				})
				// console.log(result);
				return result;
			}
		}
	},
	watch:{
		'$route'(to,from){
			//console.log(this.$router, this.$route.meta.backCounter);
			if(to.query.back) {
				this.backCounter = Number(to.query.back)+1;
				// console.log(this.backCounter);
			}
			this.getHistory(to.query);
			//console.log(to,from,arguments);
		}
	},
	methods: {

		tableDataClassName(row,index){
			// debugger;
			if(this.hidden_fields.indexOf(row.row.name)==-1) return '';
			return 'hidden';
		},
		/* Не удаляем функцию с историей цены на случай возвращения хотелок заказчиков*/ 

		// getPriceHistory(){
		// 	this.objGetParams = this.$GVO.GetAllGet();
		// 	const object_id = typeof this.$route.params.object_id == 'undefined'?'':this.$route.params.object_id;
		// 	this.$GVO.ApiCall('GET_PRICE_HISTORY',{obj:'MyObj',flt:{id:object_id}})
		// 	.then((objApi) => {
		// 		this.masHistory = [];
		// 		this.history_total = 0;
		// 		if(objApi.success === true){
		// 			if(objApi.data.length > 0){
		// 				this.masHistory = objApi.data;
		// 				if(objApi.total!=undefined) { this.history_total=objApi.total; }
		// 			}
					
		// 		}
		// 	}).catch(errorObjApi => console.log(errorObjApi));
		// },
		getHistory(filter){
			if(!filter){
				filter = {};
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					//console.log('getApi',this.objGetParams);
					filter = this.objGetParams;
				}
			}
			this.objGetParams = this.$GVO.GetAllGet();
			const object_id = typeof this.$route.params.object_id == 'undefined'?'':this.$route.params.object_id;
			this.$GVO.ApiCall('GET_HISTORY',{obj:'MyObj',flt:{id:object_id, ...filter}})
			.then((objApi) => {
				this.masHistory = [];
				this.history_total = 0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masHistory = objApi.data;
						if(objApi.total!=undefined) { this.history_total=objApi.total; }
					}
					
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.objGetParams['back'] = parseInt(this.backCounter);
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			this.$router.push({
				path: location.pathname+'?'+strItogGetParams,
				// name:'Объект история изменений',
				//params:{}
				// query:{p:parseInt(e)},
				// meta:{backCounter: this.backCounter}
			});
			this.backCounter++;
			this.getHistory();
			// this.getPriceHistory();
		},		
		GoBack(){
			// this.$router.back();
			// console.log(this.backCounter);
			this.$router.go(-this.backCounter);
		},

	},
	
	mounted() {
		this.getHistory();
		// this.getPriceHistory();
	}
};
</script>
<style >
	.el-table .hidden{
		display:none;
	}
	.el-table.my_hover .el-table__body tr:hover > td{
		background-color: rgb(1, 176, 224, 0.33) !important;
		cursor: pointer;
	}
	.MObjHistory .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
	.MObjHistory .el-table table {
		margin-bottom: 0px;
		margin-top: 0px;
	}
	.my-header {background: rgb(1, 176, 224, 0.33) !important;}
	.MObjHistory .el-table__expanded-cell {padding: 0px;}
	.datestyle {color: #01B0E0;}
	.MObjHistory .code-diff-view{
		margin:0;
	}
	.MObjHistory .code-diff-view .diff-table .blob-code-deletion, .code-diff-view .diff-table .blob-code-addition {background-color: transparent!important;}
</style>
